/* globals alert, console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const async = require('async'),
    Backbone = require('backbone'),
    BackboneRadio = require('backbone.radio'),
    _ = require('lodash'),
    //
    Organization = require('../models/organization'),
    Contacts = require('../collections/contacts'),
    //
    AddressAutocomplete = require('../utilities/addressAutocomplete'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    helpers = require('../utilities/handlebars').helpers,
    user = require('../models/user'),
    columns = {
        name: {
            type: 'text',
            display: 'Name'
        },
        countyId: {
            type: 'text',
            display: 'County'
        },
        // zip: {
        //     type: 'text',
        //     display: 'Zip code'
        // },
        phone: {
            type: 'text',
            display: 'Phone'
        },
        // contact: {
        //     type: 'text',
        //     display: 'Contact'
        // },
        // status: {
        //     type: 'text',
        //     display: 'Status'
        // },
        programs: {
            type: 'icon',
            src: configuration.assetBase + 'images/programs.svg',
            alt: 'Programs',
            initialSortDescending: true
        },
        beds: {
            type: 'icon',
            src: configuration.assetBase + 'images/units.svg',
            alt: 'Beds',
            initialSortDescending: true
        },
        vacancies: {
            type: 'icon',
            src: configuration.assetBase + 'images/vacancies.svg',
            alt: 'Vacancies',
            initialSortDescending: true
        }
    },
    url = configuration.mockdata.organizations ? '/mockdata/organizations.json'  : configuration.apiUrlBase + 'organizations',
    EOL = null;

module.exports = Backbone.Collection.extend({
    channels: {
        console: BackboneRadio.channel('console')
    },
    model: Organization,
    columns: function (raw) {
        let a = [];
        a = _.map(columns, function (column, key) {
            var o = {
                name: key,
                display: column.display,
                src: column.src,
                alt: column.alt,
                initialSortDescending: column.initialSortDescending === true ? true : false
            };
            o[column.type] = true;
            return o;
        });
        return a;
    },
    create: function (organizationSerializedValues, primaryContactSerializedValues, callback) {
        const organizationProcessedValues = formProcessor(organizationSerializedValues, 'organizations');
        let organization,
            contacts;
        async.waterfall([
            // resolve the address
            _.bind(function (callback) {
                if (organizationProcessedValues.resolveLocation) {
                    this.resolveLocation(organizationProcessedValues.zip, _.bind(function (error, location) {
                        if (error || location.error) {
                            callback(error || location.error);
                        } else {
                            callback(null, location);
                        }
                    }, this));
                } else {
                    callback(null, null);
                }
            }, this),
            _.bind(function (location, callback) {
                const values = location ? _.extend(organizationProcessedValues, location) : organizationProcessedValues;
                if (!values.countyId) {
                    delete values.countyId;
                }
                organization = new Organization(values);
                organization.save(null, {
                    success: _.bind(function (model, response, options) {
                        model.set({programs: 0, units: 0, vacancies: 0}, {silent: true});
                        callback(null, model);
                    }, this),
                    error: function (model, xhr, options) {
                        callback('Unable to create organization' + (xhr.responseJSON ? '\n(' + xhr.responseJSON.message + ')' : ''));
                    }
                });
            }, this),
            _.bind(function (organization, callback) {
                contacts = new Contacts([], {type: 'organization', id: organization.id});
                contacts.createContact(primaryContactSerializedValues, function (error) {
                    callback(error, organization);
                });
            }, this)
        ], _.bind(function (error, organization) {
            if (!error) {
                this.add(organization);
            } else {
                alert(error);
            }
            callback(error);
        }, this));
    },
    initialize: function (items, options) {
        this.listenTo(user, 'change:roles', _.bind(function () {
            this.channels.console.trigger('log', 'organizations.change:roles @' + new Date().getTime());
            this.reload();
        }, this));
        this.resolveLocation = new AddressAutocomplete().resolveLocation;
        if (!options.skipReload) {
            this.reload();
        }
    },
    reload: function () {
        this.fetch({
            headers: user.authorizationHeader('organizations'),
            method: 'GET',
            reset: true,
            success: _.bind(function () {this.sortAttribute(this.attributeOrder);}, this),
            url: url // + (this.options.programId || 1), // @acavan!
        });
    },
    rows: function () {
        let a = [],
            properties = _.keys(columns);
        if (this.length) {
            a = _.map(this.models, function (model) {
                let json = model.toJSON(),
                    o = {
                        id: json.id,
                        values: {}
                    };
                _.each(properties, function (property) {
                    switch (property) {
                        case 'phone':
                        case 'phoneNumbersOnly':
                            o.values[property] = helpers.telephone(json[property]);
                            break;
                        case 'countyId':
                            o.values[property] = helpers.countyName(json[property]);
                            break;
                        default:
                            o.values[property] = json[property];
                            break;
                    }
                });
                return o;
            });
        }
        return a;
    },
    sortAttribute: function (attributeOrder) {
        // DWR! we rely (foolishly no doubt...) on the countyIds to correspond to the county names alphabetical order
        const numerics = {
                countyId: true
            };
        let attribute,
            isAscending,
            sortWeight;
        if (attributeOrder) {
            this.attributeOrder = attributeOrder;
            isAscending = attributeOrder.order === 'ascending';
            attribute = attributeOrder.attribute;
            // lot of effort to just sort some objects by either string or number...
            if (numerics[attribute]) {
                sortWeight = isAscending ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
            } else {
                sortWeight = isAscending ? '_' : ' ';
            }
            this.reset(_.orderBy(
                this.models,
                function (model) {
                    let value = model.get(attributeOrder.attribute);
                    // don't let zero values fall to the end of the list
                    // otherwise, force empty values to the end of the sort
                    return (value === 0 ? 0 : (value || sortWeight));
                },
                isAscending ? 'asc' : 'desc'
            ));
        }
        return this.attributeOrder;
    },
    states: function () {
        let a = [];
        if (this.length) {
            a = _.map(this.models, function (model) {
                return model.attributes.state;
            });
        }
        return _.uniq(a).sort();
    }
});
